import { forwardRef, type Ref, type SVGProps } from "react";
const IconPiggyBankFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M28 12h-1a10.7 10.7 0 0 0-3-3.7V3.5a.5.5 0 0 0-.5-.5c-1.9 0-5.8.3-7.5 2.8a.5.5 0 0 1-.5.2h-.7a10.9 10.9 0 0 0-10.2 7 1 1 0 0 1-.6-1 1 1 0 1 0-2 0 3 3 0 0 0 2.1 2.9 10 10 0 0 0-.1 1.6 10.5 10.5 0 0 0 4 8.2V28a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v.5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2.6a10 10 0 0 0 1.6-1.1 1 1 0 0 1 .6-.3H28a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2m-12 1h-3a1 1 0 0 0-1 .8 1 1 0 0 0 0 .2 1 1 0 0 1-2 0 3 3 0 0 1 2.8-3H16a1 1 0 0 1 0 2m6 3a1 1 0 1 1 1-1 1 1 0 0 1-1 1"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPiggyBankFilledSVG);
ForwardRef.displayName = "IconPiggyBankFilled";
export { ForwardRef as IconPiggyBankFilled };
